const l = {
  id: "MegaMillions",
  name: "Mega Millions®",
  style: {
    colorPrimary: "#2c2b7c",
    extraBall: {
      bg: "#2c2b7c",
      color: "#ffffff"
    }
  }
};
export {
  l as default
};
